import React from 'react'
import styled from 'styled-components'

export interface HotJarNPSSurveyProps {
  className?: string
}

const Container = styled.div`
  width: 100%;

  &:not(:empty) {
    margin-top: 20px;
  }
`

export const HotJarNPSSurvey: React.FC<HotJarNPSSurveyProps> = ({ className }) => {
  return <Container className={className} id="hotjar-nps-survey" />
}
